/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import {
  Table, TableHead, TableBody, TableCell, TableRow,
  Card,
  CardContent,
} from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';
import { CommonButton, CommonModal } from '../../CommonComponents';
import { showToast } from '../../Utils';
import { updateSiteActionableItem } from '../../redux/actions/sites';

function ReportsSubTable({
  open, site, handleViewDetails, updateActionable,
}) {
  const [showModal, setShowModal] = useState(null);
  const [reason, setReason] = useState('');
  const renderType = (type) => {
    switch (type) {
      case 'sd':
        return 'Start Date';
      case 'ed':
        return 'End Date';
      case 'night':
        return 'Night Photo';
      default:
        return 'Proposed Photo';
    }
  };

  const handleAction = (task, action) => {
    updateActionable(site.id, task.id, action, reason);
  }

  const handleReject = () => {
    if (!reason.trim().length) {
      showToast('warn', 'Please provide valid reason for reject.')
      return;
    }
    setReason('');
    const task = { ...showModal };
    handleAction(task, false);
    setShowModal(null);
  }

  return (
    <>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {site?.actionabletasks?.length > 0
              ? (
                <Box margin={1}>
                  <Table size="small" aria-label="purchases">
                    <TableHead>
                      <TableRow>
                        <TableCell><b>Type</b></TableCell>
                        <TableCell><b>Date</b></TableCell>
                        <TableCell><b>Latitude</b></TableCell>
                        <TableCell><b>Longitude</b></TableCell>
                        <TableCell><b>Details</b></TableCell>
                        <TableCell><b>Auditor Comment</b></TableCell>
                        <TableCell><b>Admin Comment</b></TableCell>
                        <TableCell><b>Action</b></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {site?.actionabletasks?.map((task) => (
                        <TableRow
                          key={task.id}
                          style={{
                            backgroundColor: task.adminAction && task.adminComments && (task.auditorAction === '0' || task.auditorAction === null) ? '#f6c5d3' : 'transparent',
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {renderType(task.type)}
                          </TableCell>
                          <TableCell>
                            {task.date}
                          </TableCell>
                          <TableCell>{task.latitude}</TableCell>
                          <TableCell>{task.longitude}</TableCell>
                          <TableCell>
                            <CommonButton
                              onClick={() => handleViewDetails(site, task)}
                              basic="true"
                              color="primary"
                              className="pl-0"
                            >
                              <b>View Details</b>
                            </CommonButton>
                          </TableCell>
                          <TableCell>
                            {(parseInt(task.auditorAction, 10) !== 1 && task.auditorComments)
                              ? (
                                task.auditorComments
                              ) : '-'}
                          </TableCell>
                          <TableCell>
                            {(parseInt(task.auditorAction, 10) !== 1
                            && task.adminAction && task.adminComments)
                              ? (
                                task.adminComments
                              ) : '-'}
                          </TableCell>
                          <TableCell>
                            {(task.auditorAction === null || task.auditorAction === undefined)
                              ? (
                                <div className="flex flex-row items-center">
                                  <CommonButton variant="contained" basic="true" color="primary" onClick={() => handleAction(task, true)}>Approve</CommonButton>
                                  &nbsp;&nbsp;
                                  <CommonButton variant="contained" basic="true" color="secondary" onClick={() => setShowModal(task)}>Reject</CommonButton>
                                </div>
                              ) : <b>{parseInt(task.auditorAction, 10) ? 'Approved' : 'Rejected'}</b> }
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </Box>
            )
              : (
                <Box margin={1}>
                  <Typography variant="h6" gutterBottom component="div">No reports available</Typography>
                </Box>
            )}
          </Collapse>
        </TableCell>
      </TableRow>
      <CommonModal
        open={showModal}
        title="Provide Reject Reason"
        width="md"
        padded={false}
        onYes={() => {
          handleReject();
        }}
        onClose={() => {
          setReason('');
          setShowModal(null);
        }}
        cancelButtonText="Cancel"
        successButtonText="Reject"
      >
        <Card>
          <CardContent>
            <div className="row">
              <div className="col-12">
                <textarea value={reason} className="form-control" rows="3" placeholder="Enter reject reason" style={{ resize: 'none' }} onChange={(e) => setReason(e.target.value)} />
              </div>
            </div>
          </CardContent>
        </Card>
      </CommonModal>
    </>
  );
}

const mapActions = {
  updateActionable: updateSiteActionableItem,
};

export default connect(null, mapActions)(ReportsSubTable);
